import React from 'react';

import IconArrow from '@components/Images/Rebranding/IconArrow';
import { SUGGESTED_PROMPT_QUERY_PARAM } from '@components/pages/AI/DeepResearch/constants';
import useEventTracking from '@hooks/useEventTracking';
import { deep_research_path } from '@routes';
import { ClickTarget, click } from '@tracking';

interface EndOfArticleDeepResearchPromptProps {
  prompt: string;
}

const Prompt = ({ prompt }: EndOfArticleDeepResearchPromptProps) => {
  const { trackEvent } = useEventTracking();

  const handleClick = () => {
    trackEvent(
      click({
        clickTarget: ClickTarget.AISuggestedPrompt,
        clickText: prompt,
      })
    );
  };

  return (
    <a
      className="group flex items-center justify-between gap-x-10 rounded-[18px] border border-solid border-grayscale-beige px-16 py-8 transition-colors duration-200 ease-in-out hover:bg-grayscale-beige active:border-primary-magenta active:bg-primary-magenta dark:border-primary-pink dark:hover:bg-[var(--light-grayscale-charcoal)]"
      href={deep_research_path({ [SUGGESTED_PROMPT_QUERY_PARAM]: prompt })}
      onClickCapture={handleClick}
    >
      <span className="font-suisse-screen text-disclosure-lg text-primary-black group-active:text-white">
        {prompt}
      </span>
      <IconArrow
        className="shrink-0 rotate-180 text-primary-magenta transition-colors duration-200 ease-in-out group-active:text-white dark:group-active:text-primary-magenta"
        width={14}
        height={14}
      />
    </a>
  );
};

export default Prompt;
